import numeral from "numeral";

class Numeral {
  constructor() {
    return this.transform;
  }

  transform(number, format = "0,0[.]00") {
    return numeral(number).format(format);
  }
}

const numeralFnc = () => new Numeral();

export default numeralFnc;



// WEBPACK FOOTER //
// ./src/filters/numeral/numeral.filter.js